import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { REQUETE_DE_FOND } from '../interceptors/error.interceptor';

/**
 * Compteurs « en attente de mon action » par file, pour les pastilles du menu latéral.
 * Réponse de {@code GET /api/me/action-counts} : dictionnaire clé logique → nombre
 * (ex. `{ "president.rapports": 3, "conseil.plans": 2 }`). Le serveur ne renvoie que les
 * files pertinentes pour les rôles de l'utilisateur courant (scope garanti côté serveur).
 * Le Bearer OIDC est posé par l'intercepteur ; apiBaseUrl = '/api' relatif (proxy, même origine).
 */
@Injectable({ providedIn: 'root' })
export class ActionCountsApi {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiBaseUrl}/me/action-counts`;

  /**
   * Derniers compteurs reçus — le layout poll, les écrans qui affichent une pastille (onglets du hub
   * « التواصل مع مراقبي الدولة ») LISENT ce signal au lieu de relancer leur propre requête.
   */
  readonly dernier = signal<Record<string, number>>({});

  /** Un POLL du layout : requête de FOND — son 401 se répare en silence, jamais en naviguant. */
  get(): Observable<Record<string, number>> {
    return this.http.get<Record<string, number>>(this.url, {
      context: new HttpContext().set(REQUETE_DE_FOND, true),
    }).pipe(tap((c) => this.dernier.set(c ?? {})));
  }
}
